import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import clsx from "clsx";
import * as React from "react";

interface ScrollareaViewportProps
  extends React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Viewport> {}

interface ScrollAreaProps
  extends React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Root> {
  disableHorizontalScroll?: boolean;
  viewportProps?: Omit<ScrollareaViewportProps, "children">;
  classNames?: {
    root?: string;
    viewport?: string;
    scrollbar?: string;
    thumb?: string;
    corner?: string;
  };
}

const ScrollArea = React.forwardRef<
  React.ElementRef<typeof ScrollAreaPrimitive.Viewport>,
  ScrollAreaProps
>((props, ref) => {
  const {
    children,
    className,
    classNames,
    disableHorizontalScroll = false,
    viewportProps,
    ...rest
  } = props;
  return (
    <ScrollAreaPrimitive.Root
      className={clsx(
        "ox-reset ox-ScrollAreaRoot",
        className,
        classNames?.root,
      )}
      {...rest}
    >
      <ScrollAreaPrimitive.Viewport
        ref={ref}
        {...viewportProps}
        className={clsx("ox-reset ox-ScrollAreaViewport", classNames?.viewport)}
      >
        {children}
      </ScrollAreaPrimitive.Viewport>
      {/* Vertical Scrollbar  */}
      <ScrollAreaPrimitive.Scrollbar
        orientation="vertical"
        className={clsx(
          "ox-reset ox-ScrollAreaScrollbar",
          classNames?.scrollbar,
        )}
      >
        <ScrollAreaPrimitive.Thumb
          className={clsx("ox-reset ox-ScrollAreaThumb", classNames?.thumb)}
        />
      </ScrollAreaPrimitive.Scrollbar>
      {/* Horizontal Scrollbar */}
      {!disableHorizontalScroll ? (
        <ScrollAreaPrimitive.Scrollbar
          orientation="horizontal"
          className={clsx(
            "ox-reset ox-ScrollAreaScrollbar",
            classNames?.scrollbar,
          )}
        >
          <ScrollAreaPrimitive.Thumb
            className={clsx("ox-reset ox-ScrollAreaThumb", classNames?.thumb)}
          />
        </ScrollAreaPrimitive.Scrollbar>
      ) : null}
      {/* Scrollbar Corner  */}
      <ScrollAreaPrimitive.Corner
        className={clsx("ox-reset x-ScrollAreaCorner", classNames?.corner)}
      />
    </ScrollAreaPrimitive.Root>
  );
});

ScrollArea.displayName = "ScrollArea";
export { ScrollArea };
export type { ScrollAreaProps };
